function createLivePlugin() {
  let siteData = new Map();

  function get(obj, path) {
    if (!path) return undefined;

    const normalized = path.replace(/\[(["']?)(.*?)\1\]/g, ".$2").replace(/^\./, "");

    return normalized.split(".").reduce((o, key) => o?.[key], obj);
  }

  function loadData(filename) {
    if (!siteData.has(filename)) {
      const promise = fetch(`/assets/json/${filename}.json`, {
        cache: "no-cache",
      })
        .then((r) => (r.ok ? r.json() : Promise.reject("Network error")))
        .then((data) => (Array.isArray(data) ? data[0] : data))
        .catch((err) => {
          siteData.delete(filename);
          throw err;
        });
      siteData.set(filename, promise);
    }
    return siteData.get(filename);
  }

  const xLiveUpdates = new Set();

  Alpine.directive("live", (el, { value, modifiers, expression }, { Alpine, effect, cleanup, evaluate }) => {
    if (modifiers.includes("callback")) return;

    const noop = modifiers.includes("noop");

    const attrName = el.getAttribute("x-live.attr") || null;

    const update = async () => {
      try {
        const data = await loadData(value);
        let val = get(data, expression);
        if (val == undefined) return;

        const callbackExpression = el.getAttribute("x-live.callback");
        if (callbackExpression) {
          val = evaluate(callbackExpression, {
            scope: { $liveValue: val },
          });
        }

        if (noop || val === undefined) return;

        if (attrName) {
          el.setAttribute(attrName, val);
        } else {
          el.textContent = val;
        }
      } catch (error) {
        console.error(`[x-live] Error loading ${value}:`, error);
      } finally {
        xLiveUpdates.delete(update);
      }
    };

    if (document.readyState === "complete") {
      const scheduler = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
      scheduler(update);
    } else {
      xLiveUpdates.add(update);
    }

    cleanup(() => xLiveUpdates.delete(update));
  });

  const runAll = () => {
    const scheduler = window.requestIdleCallback || ((cb) => setTimeout(cb, 0));
    xLiveUpdates.forEach((updateFn) => scheduler(updateFn));
  };

  if (document.readyState === "complete") {
    runAll();
  } else {
    window.addEventListener("load", runAll, { once: true });
  }
}
export { createLivePlugin };
